export default __webpack_public_path__ + "static/media/andrei_vladescu.5946a76b.png";